@if (!loading) {
  <div class="row mx-0">
    <div class="col-4 px-0 text-start">
      <h3>{{ client.humanizedName }}</h3>
    </div>
    @if (displayedConfigs.length > 0) {
      <div class="col-8 px-0 text-end">
        <a routerLink="/capture-admin/client-management/clients/{{client.id}}/options-change-log">
          <span>Change Log</span>
        </a>
      </div>
    }
  </div>
  <form
    #configForm="ngForm"
    class="config-form"
    (ngSubmit)="onFormSubmit(configForm)"
    [ngClass]="{ submitted: configForm.submitted }"
    >
    <h5 class="mb-0">Add Configuration</h5>
    <ng-select
      #ngSelectControl
      bindLabel="title"
      placeholder="Select a config"
      name="selected-available-option"
      class="option-selector"
      [items]="selectableDefinitions"
      [disabled]="selectableDefinitions.length === 0"
      [(ngModel)]="selectedDefinition"
      (change)="onAddNewConfig(ngSelectControl)"
      />
    <h5 class="mt-3 mb-0">Configuration Values</h5>
    @if (displayedConfigs.length > 0) {
      <div class="configuration-values px-1 mb-1 border rounded">
        @for (config of displayedConfigs; track trackByConfig($index, config)) {
          <div class="row my-2 ps-1">
            <div class="col-4 config-title">
              <app-client-configuration-title
                [deactivated]="config.deactivated"
                [editorType]="config.editorType"
                [definition]="config.definition"
                [configOption]="config.configOption"
                />
            </div>
            <div class="col-6 config-editor">
              @switch (config.editorType) {
                @case (editorTypes.dated) {
                  <app-client-configuration-dated-value
                    [definition]="config.definition"
                    [deactivated]="config.deactivated"
                    [identifier]="config.identifier"
                    [configOption]="config.configOption"
                    [errors]="config.errors"
                    (optionChange)="onDatedChange(config, $event)"
                    />
                }
                @case (editorTypes.multiselect) {
                  <app-client-configuration-multiselect
                    [definition]="config.definition"
                    [options]="config.multiselectOptions"
                    [selected]="config.multiselectSelected"
                    (selectedChange)="onMultiSelectChange(config, $event)"
                    />
                }
                @case (editorTypes.suboptions) {
                  <app-client-configuration-suboptions
                    [definition]="config.definition"
                    [suboptionChoices]="config.suboptionChoices"
                    (choicesChange)="onSuboptionsChange(config, $event)"
                    />
                }
                @default {
                  <div class="basic-value-container">
                    <app-client-configuration-basic-value
                      [definition]="config.definition"
                      [identifier]="config.identifier"
                      [errors]="config.errors"
                      [value]="config.configOption.value"
                      (valueChange)="onBasicChange(config, $event)"
                      />
                  </div>
                }
              }
            </div>
            <div class="col-1">
              <app-client-configuration-disableable
                  [definition]="config.definition"
                  [configOption]="config.configOption"
                  (enableChange)="onEnableChange(config, $event)"
                  />
            </div>
            <div class="col-1 audit">
              @if (config.configOption.id !== undefined;) {
                <div>
                  <a routerLink="/capture-admin/change-log/ClientConfigurationOption/{{ config.configOption.id }}">
                    <span>Change Log</span>
                  </a>
                </div>
              }
            </div>
          </div>
          @if (config.dependencyWarning) {
            <div class="row ps-1">
              <div class="col-8 offset-4">
                <div class="alert alert-warning py-1 px-2 mb-0 dependency-warning">
                  {{ config.dependencyWarning }}
                </div>
              </div>
            </div>
          }
          <hr />
        }
      </div>
    }
    @if (displayedConfigs.length === 0) {
      <div>
        <div>
          No configuration values assigned.
        </div>
      </div>
    }
    @if (displayedConfigs.length !== 0) {
      <div class="text-end actions">
        <button type="submit" class="btn btn-primary" [disabled]="saving || configForm.invalid">Save</button>
        <button type="button" class="btn btn-secondary" [disabled]="saving" (click)="onCancelClick()">Cancel</button>
      </div>
    }
  </form>
} @else {
  <mat-spinner />
}
